var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1303_5453)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48953 0.423599L0.857782 3.04635C0.714072 3.19904 0.714072 3.43258 0.857782 3.5763C1.00149 3.72001 1.24401 3.72001 1.38773 3.5763L3.75003 1.214L6.11234 3.5763C6.26504 3.72001 6.49854 3.72001 6.64229 3.5763C6.78599 3.43259 6.78599 3.19905 6.64229 3.04635L4.01953 0.423599C3.86684 0.279889 3.63325 0.279889 3.48953 0.423599Z",
    fill: "#F86557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1303_5453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6.5,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.953b69e7f7735aabc0b41f30820cd3cb.svg";
export { ForwardRef as ReactComponent };